import React from "react";

import { Button } from "@mui/material";

const MaterialButton = (props) => {
  const { label } = props;
  return (
    <Button
      fullWidth
      {...props}
      sx={{
        backgroundColor: "#06623B",
        padding: "10px 0",
        color: "#fff",
        borderRadius: "30px",
        fontSize: "18px",
        fontWeight: 700,
        fontStyle: "normal",
        textTransform: "none",
        letterSpacing: "1px",
        "&:hover": {
          backgroundColor: "#06623B",
        },
      }}
    >
      {label}
    </Button>
  );
};

export default MaterialButton;
